.logo {
    max-width: 1.5em;
    max-height: 1.5em;
}
.logo.big {
    font-size: 3rem;
}
